import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { ServiceManageContent } from "../Component/ServiceManageContent";

const ServiceManage = () => {
  const seoData = getSEOData("/service-management");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <ServiceManageContent />
    </>
  );
};

export default ServiceManage;
